import type { CheminéesBootstrap } from "@/types/global";

const EMPTY: CheminéesBootstrap = {
  site: { name: "", url: "", home: "/", locale: "fr_CA" },
  options: {
    phone: null,
    email: "",
    address: "",
    hours: "",
    rbq: "",
    privacy: null,
  },
  menus: { main: [] },
  page: { id: 0, title: "", path: "/", is_404: false },
  pages: {},
};

export function getBootstrap(): CheminéesBootstrap {
  return typeof window !== "undefined" && window.cheminees ? window.cheminees : EMPTY;
}
